import { useEffect } from "react";
import { Link } from "react-router-dom";
import Card from "../../components/card/card.js";
import Aos from "../../components/aos/aos.js";
import moobooStore from "../../image/portfolio/mooboo store.jpg";
import buzzstone from "../../image/portfolio/buzzstone blog.jpg";
import eduma from "../../image/portfolio/eduma school.jpg";
const Projects = () => {
    useEffect(() => {
        Aos(1000)
    })
    return (
        <div className="w-full flex flex-col justify-center items-center bg-black/30 space-y-4 mt-8 py-4 rounded-lg">
            <div className="text-3xl font-extrabold font-mono text-white text-center w-auto " data-aos="fade-down"> <span className='text-yellow-300'>MY</span> PROJECTS</div>
            <div className="text-sm px-4 text-white font-semibold" data-aos="zoom-down">I values clients' satifactions while handling any project. My expertise is topnotch!</div>
            <div className="grid grid-cols-1 md:grid-cols-3 place-items-center gap-y-8 w-full h-[500px] overflow-auto">
            <Card image={moobooStore} builtWith="React/Axios, PHP/Laravel, MYSQL"
         clientName="Emeka Williams" projectName="Fashions e-store web app "
          
          year="2023" description="Multi-pages, Beautiful Ui and Ux, user signup, user login, admin dashboard, user dashboard, payment gateway(paystack, fluterwave, stripe) etc"
           />   
        <Card image={buzzstone} builtWith="React/Axios, PHP/Laravel, MYSQL"
         clientName="Lynda Smith" projectName="Blog web app "
          
          year="2023" description="Multi-pages, Beautiful Ui and Ux, authors & admin signup, authors & admin login, authors & admin dashboard etc"
           />   
        <Card image={eduma} builtWith="React/Axios, PHP/Laravel, MYSQL"
         clientName="Rakibian Aslam" projectName="School web app "
          
          year="2023" description="Multi-pages, Beautiful Ui and Ux, signup, login, students dashboard, teachers dashboard, admin dashboard, payment gateway(stripe) etc"
           />  
            </div>
            <Link reloadDocument data-aos="fade-up" to="/projects" className='bg-yellow-500 px-2 py-4 text-white font-bold rounded-lg text-center'>View More</Link>
        </div>
    );
}

export default Projects;